import { CompanyEmployeeCountPage } from './pages/company-employee-count';
import { CompanyGetStartedPage } from './pages/company-get-started';
import { CompanyIndustry } from './pages/company-industry';
import { CompanyNamePage } from './pages/company-name';
import { CompanyTheme } from './pages/company-theme';
import { CompanyUserSetInfoPage } from './pages/company-user-set-info';

export const routes = [
  {
    name: 'setUserInfo',
    path: 'set-user-info',
    page: <CompanyUserSetInfoPage />,
  },
  {
    name: 'companyGetStarted',
    path: 'company-get-started',
    page: <CompanyGetStartedPage />,
  },
  {
    name: 'companyName',
    path: 'company-name',
    page: <CompanyNamePage />,
  },
  {
    name: 'companyEmployeeCount',
    path: 'company-employee-count',
    page: <CompanyEmployeeCountPage />,
  },
  {
    name: 'companyIndustry',
    path: 'company-industry',
    page: <CompanyIndustry />,
  },
  {
    name: 'companyTheme',
    path: 'company-theme',
    page: <CompanyTheme />,
  },
] as const;
